module.exports = __webpack_public_path__ + "img/DecorationConcept.1165d9fc.webp";